import { Routes } from '@angular/router';
import { authGuard } from './core/auth.guard';
import { activeGuard } from './core/active.guard';
import { roleGuard } from './core/role.guard';
import { consentGuard } from './core/consent.guard';
import { UserRole } from './core/types';
import { devRoutes } from './app.routes.dev';

export const routes: Routes = [
  ...devRoutes,
  {
    path: '',
    loadComponent: () => import('./features/public/public-info.component').then((m) => m.PublicInfoComponent),
    pathMatch: 'full',
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./features/public/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'docs',
    loadComponent: () =>
      import('./features/docs/documentation.component').then((m) => m.DocumentationComponent),
  },
  {
    path: '',
    loadComponent: () => import('./shared/layout/app-layout.component').then((m) => m.AppLayoutComponent),
    canActivate: [authGuard, activeGuard, consentGuard],
    children: [
      {
        path: '',
        redirectTo: 'calendar',
        pathMatch: 'full',
      },
      {
        path: 'calendar',
        loadComponent: () => import('./features/calendar/calendar.component').then((m) => m.CalendarComponent),
      },
      {
        path: 'booking',
        loadComponent: () => import('./features/booking/booking-wizard.component').then((m) => m.BookingWizardComponent),
      },
      {
        path: 'sessions',
        loadComponent: () => import('./features/sessions/sessions.component').then((m) => m.SessionsComponent),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./features/notifications/notifications-page.component').then((m) => m.NotificationsPageComponent),
      },
      {
        path: 'storage',
        loadComponent: () => import('./features/storage/storage-page.component').then((m) => m.StoragePageComponent),
      },
      {
        path: 'launch-profiles',
        loadComponent: () =>
          import('./features/launch-profiles/launch-profiles-page.component').then((m) => m.LaunchProfilesPageComponent),
      },
      {
        path: 'credentials',
        loadComponent: () => import('./features/credentials/credentials.component').then((m) => m.CredentialsComponent),
      },
      {
        path: 'billing',
        loadComponent: () => import('./features/billing/billing.component').then((m) => m.BillingComponent),
      },
      {
        path: 'account',
        loadComponent: () => import('./features/account/account.component').then((m) => m.AccountComponent),
      },
      {
        path: 'admin',
        canActivate: [roleGuard(UserRole.Owner)],
        children: [
          {
            path: 'alerts',
            loadComponent: () => import('./features/admin/admin-alerts.component').then((m) => m.AdminAlertsComponent),
          },
          {
            path: 'availability',
            loadComponent: () => import('./features/admin/admin-availability.component').then((m) => m.AdminAvailabilityComponent),
          },
          {
            path: 'bookings',
            loadComponent: () => import('./features/admin/admin-bookings.component').then((m) => m.AdminBookingsComponent),
          },
          {
            path: 'users',
            loadComponent: () => import('./features/admin/admin-users.component').then((m) => m.AdminUsersComponent),
          },
          {
            path: 'images',
            loadComponent: () => import('./features/admin/admin-images.component').then((m) => m.AdminImagesComponent),
          },
          {
            path: 'metrics',
            loadComponent: () => import('./features/admin/admin-metrics.component').then((m) => m.AdminMetricsComponent),
          },
          {
            path: 'storage-policy',
            loadComponent: () =>
              import('./features/admin/storage-policy-page.component').then((m) => m.StoragePolicyPageComponent),
          },
          {
            path: 'settings',
            loadComponent: () => import('./features/admin/admin-settings.component').then((m) => m.AdminSettingsComponent),
          },
          {
            path: 'invitations',
            loadComponent: () => import('./features/admin/admin-invitations.component').then((m) => m.AdminInvitationsComponent),
          },
        ],
      },
    ],
  },
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
      },
      {
        path: 'register',
        loadComponent: () => import('./features/auth/register.component').then((m) => m.RegisterComponent),
      },
      {
        path: 'verify-email',
        loadComponent: () => import('./features/auth/verify-email.component').then((m) => m.VerifyEmailComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./features/auth/forgot-password.component').then((m) => m.ForgotPasswordComponent),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./features/auth/reset-password.component').then((m) => m.ResetPasswordComponent),
      },
      {
        path: 'pending-approval',
        loadComponent: () => import('./features/auth/pending-approval.component').then((m) => m.PendingApprovalComponent),
      },
      {
        path: 'privacy-consent',
        loadComponent: () =>
          import('./features/auth/privacy-consent.component').then((m) => m.PrivacyConsentComponent),
      },
      {
        path: 'invite-register/:token',
        loadComponent: () => import('./features/auth/invite-register/invite-register.component').then((m) => m.InviteRegisterComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
